import { useFetchWrapper } from 'helpers';
import { Dashboard } from 'states';
import { APIS } from '../constants';

export { useDashboardService };

// The single-dashboard endpoint also returns the raw `filters` JSON string.
export type DashboardDetail = Dashboard & { filters?: string };

const useDashboardService = () => {
  const baseUrl = `${process.env.REACT_APP_BASE_API_URL}`;
  const fetchWrapper = useFetchWrapper();

  const createOrUpdateDashboard = (newDashboard: Dashboard) => {
    return fetchWrapper.post(
      new URL(`${baseUrl}${APIS.DASHBOARD.ADD_UPDATE_DASHBOARD}`),
      newDashboard
    );
  };

  const getDashboards = () => {
    return fetchWrapper.get<Dashboard[]>(new URL(`${baseUrl}${APIS.DASHBOARD.GET_ALL_DASHBOARD}`));
  };

  const getDashboardsForRole = (roleId: number) => {
    return fetchWrapper.get<Dashboard[]>(
      new URL(`${baseUrl}${APIS.DASHBOARD.GET_DASHBOARDS_FOR_ROLE}${roleId}`)
    );
  };

  const getDashboard = (dashboardId: string, profileName: string) => {
    return fetchWrapper.get<DashboardDetail[]>(
      new URL(`${baseUrl}${APIS.DASHBOARD.GET_DASHBOARD}${profileName}&dashboardId=${dashboardId}`)
    );
  };

  return { createOrUpdateDashboard, getDashboards, getDashboard, getDashboardsForRole };
};
